import { Navigate, useLocation, useParams } from "react-router-dom";
import { buildBrandArtifactPath } from "../lib/brand-navigation";

export function BrandVoiceSettings() {
  const { brandId } = useParams<{ brandId: string }>();
  const location = useLocation();

  if (!brandId) {
    return <Navigate to="/brand" replace />;
  }

  return <Navigate to={`${buildBrandArtifactPath(brandId, "voice")}${location.search}${location.hash}`} replace />;
}
